<template>
  <li :class="[taskDimension && 'task__tile']">
    <p :class="['task-name']">
      <span class="user" v-if="taskDimension">{{ user }}</span>
      <span class="name">{{ task.taskName }}</span>
    </p>
    <p class="task-status">
      <span :class="[taskStatus(task.status)]">{{
        task.status | taskText
      }}</span>
      <span v-if="task.status == 1" class="success">{{
        task.completeTime | successTime
      }}</span>
      <span v-if="task.status == 0" class="runing">{{
        task.endTime | endTime
      }}</span>
      <span v-if="task.status == 2" class="outDate">{{ task.resultDesc }}</span>
    </p>
  </li>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: ['task', 'user', 'taskDimension'],
  computed: {
    ...mapState('app', ['businessType'])
  },
  methods: {
    taskStatus(status) {
      if (status == 0) {
        return 'inprogress';
      } else if (status == 1) {
        return 'success';
      } else {
        return 'failure';
      }
    }
  },
  filters: {
    taskText(status) {
      if (status == 0) {
        return '进行中';
      } else if (status === 1) {
        return '成功邀请';
      } else {
        return '已失效';
      }
    },
    endTime(time) {
      let Month = new Date(time).getMonth() + 1;
      let Day = new Date(time).getDate();
      return `${Month}.${Day}过期`;
    },
    successTime(time) {
      let Month = new Date(time).getMonth() + 1;
      let Day = new Date(time).getDate();
      let HH = new Date(time).getHours();
      HH = HH < 10 ? `0${HH}` : HH;
      let MM = new Date(time).getMinutes();
      MM = MM < 10 ? `0${MM}` : MM;
      let SS = new Date(time).getSeconds();
      SS = SS < 10 ? `0${SS}` : SS;
      return `${Month}月${Day}日  ${HH}:${MM}:${SS}完成`;
    }
  }
};
</script>
<style lang="less" scoped>
li {
  margin-top: 15px;
  background: #fff7e8;
  border-radius: 20px;
  padding: 20px 30px;
  box-sizing: content-box;
  &:first-of-type {
    margin-top: 0px;
  }
  .fc;
  justify-content: space-between;
  .task-name {
    font-size: 26px;
    font-family: Source Han Sans SC Medium, Source Han Sans SC Medium-Medium;
    font-weight: 500;
    text-align: left;
    color: #ae0000;
    display: flex;
    flex-direction: column;
    .name {
      max-width: 318px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; // 想要几行这里写相应数字即可
      -webkit-box-orient: vertical;
    }
  }
  .task-status {
    display: flex;
    flex-direction: column;
    text-align: right;
    flex: 1;
    align-items: flex-end;
    span {
      font-size: 26px;
      font-family: Source Han Sans SC Medium, Source Han Sans SC Medium-Medium;
      font-weight: 500;
      max-width: 280px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; // 想要几行这里写相应数字即可
      -webkit-box-orient: vertical;
    }
    > .success {
      color: #21c59d;
    }
    > .inprogress {
      color: #ff5926;
    }
    > .failure {
      color: rgba(24, 29, 55, 0.65);
    }
    .outDate {
      color: rgba(24, 29, 55, 0.5);
    }
    .runing {
      color: rgba(255, 89, 38, 0.8);
      font-family: Source Han Sans SC Light;
    }
  }
  &.task__tile {
    background-color: #fff;
    margin: 0px;
    border-bottom: 1px solid #f9e6c7;
    .task-name {
      font-family: PingFang SC Regular, PingFang SC Regular-Regular;
      .user {
        font-size: 30px;
        font-family: PingFang SC Medium, PingFang SC Medium-Medium;
        font-weight: 500;
        text-align: left;
        color: #262626;
        line-height: 36px;
        margin-bottom: 20px;
      }
      .name {
        font-size: 28px;
        font-weight: 400;
        text-align: left;
        color: #8c8c8c;
      }
    }
    .task-status {
      > span {
        &:first-child {
          margin-bottom: 18px;
        }
      }
    }
  }
}
</style>
